import React from 'react';
import {assert} from 'assert-ts';
import type {HtmlProps} from './types';
import {HtmlReadonly} from './HtmlReadonly';

export const Html: React.FC<HtmlProps> = ({readonly, ...props}) => {
  assert(readonly, 'Html: only readonly is supported');
  return <HtmlReadonly {...props} />;
};
